import {environment} from "../../env";
import {B} from "../../build";
import {FronteggProvider} from "@frontegg/react";
import type {ReactNode} from "react";
import React from "react";

export const FrontEggRootWrapper: React.FC<{children?: ReactNode}> = ({children}) => {

    // The following does not work as the Router is not properly signaled by FrontEgg's redirect
    // The page URL changes, but the router does not react to this.
    // useEffect(() => {
    //     const loginUrl = routes.login;
    //     window.localStorage.setItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL', `${loginUrl}${window.location.search.toString()}`)
    // }, []);
    // @see FRONTEGG_AFTER_AUTH_REDIRECT_URL (https://developers.frontegg.com/sdks/components/auth-functions#frontegg_after_auth_redirect_url)

    return <FronteggProvider
        contextOptions={{
            baseUrl: environment.frontEggBaseUrl,
            clientId: B.FRONTEGG_CLIENT_ID,
            appId: B.FRONTEGG_APPLICATION_ID,
        }}
        hostedLoginBox={true}
        authOptions={{
            // keepSessionAlive: true // Uncomment this in order to maintain the session alive
        }}>
        {children}
    </FronteggProvider>
}
